import { postNewCalendarEvent, getRoutedBuilding } from '../api.js'

import pageApiData from '../utils/pageApiData.js'
import notifications from '../notifications.js'

const [ _getRoutedBuildingFromServer, _getRoutedBuilding, _getRoutedBuildingSync ] = pageApiData.createFunctions(getRoutedBuilding, 'Unable to get buildings from server.', function (code) { return elem => elem.code === code })

function _postNewCalendarEvent(content) {
  let promise = postNewCalendarEvent(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _init() {
  // do nothing
}

_init()

export default {
  getRoutedBuildingFromServer: _getRoutedBuildingFromServer,
  getRoutedBuilding: _getRoutedBuilding,
  getRoutedBuildingSync: _getRoutedBuildingSync,

  postNewCalendarEvent: _postNewCalendarEvent,
}
